<app-tile-layout maxCols="4">
  <app-summary-tile *ngFor="let summary of summaries" [summary]="summary"></app-summary-tile>
</app-tile-layout>
